module.exports = __webpack_public_path__ + "img/dark-green-circle-table-10.a5620ec4.png";